import React from 'react';

import { Action, Actions } from '@gogame/components';

const CampaignsAllPagesBulkActions = ({ onChangeOwner }) => {
  return (
    <Actions>
      <Action button={true} label={'Change owner'} onClick={onChangeOwner} />
    </Actions>
  );
};
export default CampaignsAllPagesBulkActions;
